import styled from 'styled-components';

export const HeaderText = styled.p`
  font-size: 26px;
  color: var(--cp-text, #fff);
`;

export const TariffManageWrapper = styled.div`
  width: 100%;
  form {
    position: relative;
    display: flex;
    //justify-content: space-between;
    align-items: flex-start;
  }
`;
